'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

RasterScheduleDirective=class RasterScheduleDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'displayTimeZone',
'timezoneDescription',
'estimatesAsOfTime',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'timeOfLastHosStatus',
'predictedWorkday',
'forecastDutyInterval',
'dutyFormatter',
'tripFormatter',
'flightFormatter',
'sleepFormatter',
'sleepPromotingFormatter',
'personalStatistics'];
}

get templateUrl(){
return'/templates/features/personalSchedule/components/rasterSchedule/rasterScheduleView';
}

get controller(){
return RasterScheduleDirectiveController;
}};let


RasterScheduleDirectiveController=class RasterScheduleDirectiveController{
constructor(timeFormattingService,$element,$window,$scope){
this._timeFormattingService=timeFormattingService;

this.axisLabelFormatter=this.use24HourTimeline?Formatters.utcAxisTimeLabel_24Hour:
Formatters.utcAxisTimeLabel;

this.selectedInterval={};

const handleClick=event=>{
$scope.$evalAsync(()=>{
const focusedRect=angular.element($element).find('rect:focus');

if(!_.exists(focusedRect)||focusedRect.length===0){
this.selectedInterval={};
}
});
};

this._handleClick=handleClick.bind(this);

angular.element($window).on('click',this._handleClick);

$scope.$on('$destroy',()=>{
angular.element($window).off('click',this._handleClick);
});
}

get timeFormattingService(){
return this._timeFormattingService;
}

get use24HourTimeline(){
return this._timeFormattingService.safeUse24HourTimelineSetting;
}};


module.exports=RasterScheduleDirective;
//# sourceMappingURL=rasterScheduleDirective.js.map
